import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { connects } from "../lib/metamask";
import { color } from "../styles/theme";
import { useDispatch, useSelector } from "react-redux";
import { updateAddress } from "../store/reducers/metamask";
import { RootState } from "../store/reducers";
import { updateLoading } from "../store/reducers/loading";

const Header = () => {
	const [toggle, onToggle] = useState(true);
	const dispatch = useDispatch();

	const handleConnectMetamask = async () => {
		dispatch(updateLoading(true));
		const address = await connects.connect();
		dispatch(updateAddress(address?.address));
		dispatch(updateLoading(false));
	};

	const { address } = useSelector((state: RootState) => state.metamask);

	const simpleAddress = (address: string) => {
		return `${address.slice(0, 6)}...${address.slice(address.length - 4, address.length)}`;
	};

	return (
		<HeaderSection>
			<LogoSection>
				<LogoBox to="/">
					{/* <span className="logo">BAROQUE</span>
					<span className="logo">WORKS</span> */}
					<span className="logo">Baroque Works</span>
				</LogoBox>

				<ConnectMetaMask toggle={toggle} onClick={() => onToggle(!toggle)}>
					{address === "" ? (
						<span onClick={() => handleConnectMetamask()}>connect metamask</span>
					) : (
						<span>{simpleAddress(address)}</span>
					)}
				</ConnectMetaMask>
			</LogoSection>

			<nav>
				<Link to="/requestBugBounty">Request</Link>
				<Link to="/bountyList">Bounty list</Link>
				<div className="dashboard">
					<span>Dashboard</span>
					<Link to="/dashboard" className="dashboardItem">
						Client
					</Link>
					{/* <Link to="/hunter" className="dashboardItem">
						Hunter
					</Link> */}
				</div>
				<div
					onClick={() =>
						window.open(
							"https://app.daohaus.club/dao/0x5/0xa8540878f38c7746527517ee33e416f0f3d74fe1"
						)
					}
				>
					Governance
				</div>
			</nav>
		</HeaderSection>
	);
};

const HeaderSection = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	background: #111111;
	width: 100%;
	max-height: 55px;
	box-sizing: border-box;
	padding: 0px 30px;
	position: fixed;
	z-index: 99;

	nav {
		display: flex;
		justify-content: space-around;
		align-items: flex-start;
		width: 35rem;

		a,
		div {
			padding-top: 18px;
			color: ${color.green};
			font-weight: 400;
			font-size: 1rem;
			line-height: 33px;
			cursor: pointer;
		}

		.dashboard {
			display: flex;
			flex-direction: column;
			align-items: center;
			border: 3px solid #481c63;
			border-top: 0px;
			padding: 0.5rem 0.5rem;
			box-sizing: border-box;
			border-radius: 0px 0px 19px 19px;
			transition: all 0.3s ease-in 0s;
			background: #101010;
			cursor: pointer;

			&:hover {
				padding-top: 1rem;

				span {
					border-bottom: 3px solid ${color.green};
					margin-bottom: 1rem;
				}

				.dashboardItem {
					display: flex;
				}
			}

			.dashboardItem {
				display: none;
				padding: 0.1rem;

				&:hover {
					font-weight: bold;
				}
			}
		}
	}
`;

const LogoSection = styled.div`
	display: flex;
	align-items: flex-start;
`;

const LogoBox = styled(Link)`
	display: flex;
	text-decoration: none;

	.logo {
		/* writing-mode: vertical-lr; */
		text-orientation: upright;
		padding: 0;
		color: ${color.green};
		font-weight: 400;
		font-size: 1.6rem;
		font-style: normal;
		line-height: 29px;
		padding-top: 18px;

		&:nth-child(2) {
			margin-top: 130px;
		}
	}
`;

interface INavTab {
	toggle: boolean;
}

const ConnectMetaMask = styled.div<INavTab>`
	display: flex;
	position: relative;
	background: #101010;
	border: 3px solid #481c63;
	border-top: 0px;
	border-radius: 0px 0px 19px 19px;
	/* left: ${(props) => (props.toggle ? "-39px" : "-160px")}; */
	left: 50px;
	padding: 0.5rem 2rem;
	box-sizing: border-box;
	cursor: pointer;
	transition: all 0.3s ease 0s;

	span {
		width: fit-content;
		color: ${color.white};
		font-family: "rubik";
		font-weight: 400;
		font-size: 1rem;
		line-height: 26px;
		letter-spacing: 0.2rem;
	}
`;

export default Header;
